import $ from 'jquery'
import 'slick-carousel'
import { revalidate as revalidateLazyload } from './lazyload'

const carouselSelector = '[data-product-gallery]:not([data-product-gallery-inited])'

const previous =
  '<button type="button" data-role="none" class="slide-control previous" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>'
const next =
  '<button type="button" data-role="none" class="slide-control next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>'

const carouselOptions = {
  slidesToShow: 1,
  speed: 300,
  arrows: true,
  prevArrow: previous,
  nextArrow: next,
  easing: 'easeOutCubic',
  swipeToSlide: true,
  infinite: true,
  centerMode: false,
}

const galleryOptions = {
  variableWidth: false,
  adaptiveHeight: true,
  slidesToShow: 1,
}

export function init() {
  const $productCarousel = $(carouselSelector)

  const carouselSettings = Object.assign({}, carouselOptions, galleryOptions)
  const slickInstance = $productCarousel.slick(carouselSettings).slick('getSlick')

  $productCarousel.on('afterChange', () => {
    revalidateLazyload()
    const slickSlide = slickInstance.$slides[slickInstance.currentSlide]
    const $slide = $(slickSlide).find('[data-product-gallery-slide]')
    const imageId = $slide.data('product-gallery-slide')

    $('[data-product-image-id]').removeClass('selected')
    $(`[data-product-image-id="${imageId}"]`).addClass('selected')
  })
  $productCarousel.attr('data-product-gallery-inited', '')

  $('[data-product-image-id]').on('click', (e) => {
    const index = $(e.currentTarget).data('index')
    const isOverride = $(e.currentTarget).data('is-override') !== undefined
    if (slickInstance.currentSlide !== index) $productCarousel.slick('slickGoTo', index)
    if (isOverride) {
      const variationValue = $(e.currentTarget).data('variation')
      if (!variationValue) return
      const possibleValues = $('[data-product-option="variation"] option')
        .map((i, el) => $(el).val())
        .toArray()

      if (!possibleValues.includes(variationValue)) return
      $('[data-product-option="variation"]').val(variationValue)
    }
  })

  $('[data-product-option="variation"]')
    .on('change', (event) => {
      const val = $(event.currentTarget).val()
      const secondaryVariation = $('[data-product-option="secondary_variation"]').val()
      let $targets = $(`.product-gallery-thumbnail[data-variation="${val}"][data-secondary-variation="${secondaryVariation}"]`) // prettier-ignore
      if (!secondaryVariation || !$targets.length) $targets = $(`.product-gallery-thumbnail[data-variation="${val}"]`)
      if (!$targets.length) return
      $($targets.get(0)).trigger('click')
    })
    .trigger('change')

  $('[data-product-option="secondary_variation"]')
    .on('change', (event) => {
      const val = $(event.currentTarget).val()
      const primaryVariation = $('[data-product-option="variation"]').val()
      let $targets = $(`.product-gallery-thumbnail[data-variation="${primaryVariation}"][data-secondary-variation="${val}"]`) // prettier-ignore
      if (!primaryVariation || !$targets.length)
        $targets = $(`.product-gallery-thumbnail[data-secondary-variation="${val}"]`)
      if (!$targets.length) return
      $($targets.get(0)).trigger('click')
    })
    .trigger('change')
}
